
import {computed, defineComponent, PropType, ref, watch} from 'vue'
import {useRouter, useRoute} from 'vue-router'
import QrcodeVue from 'vue-qrcode'
import {generateTitle} from '@/utils/lang'
import {MobileMenu, MobileTab, mobileProductTabs, showMobileTabs} from '@/utils/mobilePresentation'
export default defineComponent({
  components:{QrcodeVue},
  props:{
    menus:{type:Array as PropType<MobileMenu[]>,required:true}, title:{type:String,default:''}, logo:{type:String,default:''},
    // 2026-09-30：充值显隐与点击交给共用导航处理，保持平台/分店及登录行为一致。
    rechargeVisible:Boolean, personalVisible:Boolean, loggedIn:Boolean, scaleVisible:Boolean, memberVisible:Boolean, memberTitle:{type:String,default:'购买会员'},
    serviceVisible:Boolean, serviceUrl:{type:String,default:''}, servicePhone:{type:String,default:''}, platform:Boolean
  },
  emits:['recharge','navigate','personal','security','login','scale','member','password','logout'],
  setup(props,{emit}) {
    const router=useRouter(), route=useRoute(), menuOpen=ref(false), serviceOpen=ref(false)
    const groupTitle=ref(''), groupPaths=ref<string[]>([])
    const path=computed(()=>route.path), hasTabs=computed(()=>showMobileTabs(path.value))
    const tabs=computed(()=>mobileProductTabs(props.menus))
    const pageTitle=computed(()=>{
      const title=String(route.meta.title || '')
      return title.startsWith('main.') ? generateTitle(title) : title || props.title
    })
    const displayedMenus=computed(()=>props.menus.filter(menu=>menu.enabled && (!groupTitle.value || groupPaths.value.includes(menu.path))))
    const openMenu=()=>{groupTitle.value=''; groupPaths.value=[]; menuOpen.value=true}
    const navigate=(menu:MobileMenu)=>{menuOpen.value=false;emit('navigate',menu)}
    const selectTab=(tab:MobileTab)=>{
      if(tab.menus.length===1) navigate(tab.menus[0])
      else {groupTitle.value=tab.title;groupPaths.value=tab.menus.map(menu=>menu.path);menuOpen.value=true}
    }
    const action=(name:'recharge'|'personal'|'security'|'login'|'scale'|'member'|'password'|'logout')=>{menuOpen.value=false;emit(name)}
    const goBack=()=>{if(window.history.state?.back)router.back();else router.push('/main/index')}
    watch(path,()=>{menuOpen.value=false;serviceOpen.value=false})
    return {path,hasTabs,tabs,pageTitle,menuOpen,serviceOpen,groupTitle,displayedMenus,openMenu,navigate,selectTab,action,goBack}
  }
})
